<template>
  <div class="userCenter">
    <!-- <div class="box">11</div> -->
    <div class="dashboard">
      <div class="dashboard-header">
        <div class="username">用户昵称：{{ userInfo.nickname }}</div>
        <button class="logout-btn" @click="editFn">信息修改</button>
      </div>
      <div class="application-status">
        <h3>申请状态</h3>
        <p class="status-value">{{ userInfo.is_check == '1' ? '申请成功' : '暂未申请' }}</p>
      </div>
      <div style="text-align: right;margin: 20px 0 30px 0;">
        <button @click="publish" class="logout-btn"
          style="background-color: #f0f9eb;color: #67c23a; margin-top: 20px;">发布需求</button>
        <button @click="displayFn" class="logout-btn"
          style="background-color: #f0f9eb;color: #67c23a; margin-top: 20px;margin-left: 20px;">申请展厅</button>
      </div>
      <el-tag type="success">#我的接单</el-tag>
      <el-table :data="userOrder" style="width: 100%">
        <el-table-column prop="title" label="标题" width="180">
        </el-table-column>
        <el-table-column prop="nickname" label="昵称" width="180">
        </el-table-column>
        <el-table-column prop="price" label="价格">
        </el-table-column>
        <el-table-column prop="mobile" label="手机号">
        </el-table-column>
        <el-table-column prop="number" label="稿件数量">
        </el-table-column>
        <el-table-column prop="totalPrice" label="预计总价">
        </el-table-column>
        <el-table-column prop="date" label="截稿日期">
          <template #default="{row}">{{ formatDate(row.date)}}</template>
        </el-table-column>
        <el-table-column prop="date" label="操作" align="center" width="200">
          <template #default="{ row }">
            <el-button type="warning" size="mini" @click="finish(row.id)">{{ row.type == '1' ?'完结':'已完结' }}</el-button>
            <el-button type="danger" size="mini" @click="abandon(row.id)">退单</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="发布需求" :visible.sync="centerDialogVisible" width="30%" center @close="close">
      <el-form ref="form" :model="params" label-width="80px">
        <el-form-item label="标题" :rules="titleRules" prop="title">
          <el-input v-model="params.title"></el-input>
        </el-form-item>
        <el-form-item label="昵称" :rules="nicknameRules" prop="nickname">
          <el-input v-model="params.nickname"></el-input>
        </el-form-item>
        <el-form-item label="价格" :rules="priceRules" prop="price">
          <el-input v-model="params.price"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile" :rules="mobileRules">
          <el-input v-model="params.mobile"></el-input>
        </el-form-item>
        <el-form-item label="稿件数量" prop="number" :rules="numberRules">
          <el-input v-model="params.number"></el-input>
        </el-form-item>
        <el-form-item label="预计总价" prop="totalPrice" :rules="totalPriceRules">
          <el-input v-model="params.totalPrice"></el-input>
        </el-form-item>
        <el-form-item label="截稿日期" prop="date" :rules="dateRules">
          <el-date-picker type="date" placeholder="选择日期" v-model="params.date" style="width: 100%;"></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 制作展厅 -->
    <el-dialog title="申请展厅" :visible.sync="displayVisible" width="30%" center @close="close">
      <el-form ref="displayform" :model="displayParams" label-width="80px">
        <el-form-item label="标题" :rules="titleRules" prop="title">
          <el-input v-model="displayParams.title"></el-input>
        </el-form-item>
        <el-form-item label="制作类型" :rules="sortRules" prop="sort">
          <el-input v-model="displayParams.sort"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile" :rules="mobileRules">
          <el-input v-model="displayParams.mobile"></el-input>
        </el-form-item>
        <el-form-item label="展厅图片" :rules="imgRules" prop="img">
          <div class="imgUloadBox">
            <Imgupload :url="displayParams.img" @imgUrlFn="imgUrlFn2" />
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="displayVisible = false">取 消</el-button>
        <el-button type="primary" @click="displayConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 信息修改 -->
    <el-dialog title="信息修改" :visible.sync="editVisible" width="30%" center @close="close">
      <el-form ref="editform" :model="userInfo" label-width="80px">
        <el-form-item label="昵称" :rules="nicknameRules" prop="nickname">
          <el-input v-model="userInfo.nickname"></el-input>
        </el-form-item>
        <el-form-item label="用户头像" :rules="logoRules" prop="logo">
          <div class="imgUloadBox">
            <Imgupload :url="userInfo.logo" @imgUrlFn="imgUrlFn" />
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" @click="editConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import { publish_informationApi, take_information_listApi, userInfoApi, abandonOrderApi, update_user_infoApi, applyDisplayApi, finishOrderApi } from "../api/index";
import myform from "./components/myform.vue";
import Imgupload from '../components/Imgupload'
export default {
  data() {
    return {
      userInfo:{},
      centerDialogVisible: false,
      displayVisible: false,
      editVisible:false,
      // img:"",
      params:{
        title: '',
        nickname: "",
        price: null,
        mobile: null,
        number: null,
        totalPrice: null,
        date: null,
      },
      displayParams: {
        title: '',
        sort: '',
        mobile: null,
        img:""
      },
      titleRules: [
        { required: true, message: '请输入标题', trigger: 'blur' },
      ],
      nicknameRules: [
        { required: true, message: '请输入昵称', trigger: 'blur' },
      ],
      priceRules: [
        { required: true, message: '请输入价格', trigger: 'blur' },
        { pattern: /^[0-9~]+$/, message: '价格只能是数字或~单位：元/张', trigger: 'blur' },
      ],
      mobileRules: [
        { required: true, message: '请输入手机号', trigger: 'blur' },
        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确手机号', trigger: 'blur' },
      ],
      numberRules: [
        { required: true, message: '请输入稿件数量', trigger: 'blur' },
        { pattern: /^\d+$/, message: '稿件数量只能是数字', trigger: 'blur' }
      ],
      totalPriceRules: [
        { required: true, message: '请输入预计总价', trigger: 'blur' },
        { pattern: /^\d+$/, message: '预计总价只能是数字', trigger: 'blur' }
      ],
      dateRules: [
        { required: true, message: '请输入截稿日期', trigger: 'blur' },
      ],
      sortRules: [
        { required: true, message: '请输入制作类型', trigger: 'blur' },
      ],
      logoRules: [
        { required: true, message: '请输入制作类型', trigger: 'blur' },
      ],
      imgRules: [
        { required: true, message: '请上传展厅图片', trigger: 'blur' },
      ],
      userOrder: []
    };
  },
  components:{
    myform,
    Imgupload
  },
  created(){
    this.getUserOrder()
    this.getUserInfo()
  },
  methods:{
    async editConfirm(){
      const res = await update_user_infoApi(this.userInfo)
      if(res.data.code===1){
        this.$message({
          type: 'success',
          message: '修改成功!'
        })
        this.editVisible = false
      }else{
        this.$message({
          type: 'success',
          message: '修改失败!'
        })
      }
    },
    async editFn(){
      this.editVisible = true
    },
    abandon(id){
      this.$confirm('此操作将退单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const res = await abandonOrderApi({ id: id })
        if(res.data.code===1){
          this.getUserOrder()
          this.$message({
            type: 'success',
            message: '退单成功!'
          })
        }else{
          this.$message({
            type: 'error',
            message: res.data.msg
          })
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    finish(id){
      this.$confirm('您是否已完结?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await finishOrderApi({ id: id })
        if (res.data.code === 1) {
          this.getUserOrder()
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        } else {
          this.$message({
            type: 'error',
            message: res.data.msg
          })
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    displayFn() {
      this.displayVisible=true
      
    },
    displayConfirm(){
      this.$refs.displayform.validate(async (valid) => {
        if (valid) {
          const res = await applyDisplayApi({  })
          if (res.data.code === 1) {
            this.getUserOrder()
            this.$message({
              type: 'success',
              message: res.data.msg
            })
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
          this.displayVisible = false
        }
      });
    },
    confirm() {
      this.$refs.form.validate(async(valid) => {
        if (valid) {
          this.params.date = moment(this.params.date).format("YYYY-MM-DD")
          const res = await publish_informationApi(this.params)
          console.log("res", res);
          // const res = await axios.post("http://127.0.0.1:3000/jyapi/publish",this.params)
          if(res.data.code==1){
            this.$message.success('发布成功');
          }else{
            this.$message.error('发布失败');
          }
          this.centerDialogVisible = false
        } 
      });
    },
   async getUserOrder(){
     const res = await take_information_listApi()
      if (res.data.code === 1) {
        this.userOrder=res.data.data
      } 
    },
    publish(){
      this.centerDialogVisible = true
    },
    close(){
      this.getUserInfo()
      if (this.$refs.form){
        this.$refs.form.resetFields()
      }
      if (this.$refs.displayform) {
        this.$refs.displayform.resetFields()
      }
    },
    async getUserInfo() {
      const res = await userInfoApi({})
      this.userInfo = res.data.data
    },
    formatDate(value){
      return moment(value).format("YYYY-MM-DD")
    },
    imgUrlFn(imgurl) {
      this.userInfo.logo = imgurl
      // console.log('this.userphoto', this.userphoto)
    },
    imgUrlFn2(imgurl) {
      this.displayParams.img = imgurl
      // console.log('this.userphoto', this.userphoto)
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
  margin-bottom: 0;
}
.userCenter {
  padding-top: 70px;
  padding-bottom: 50px;
}



body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f4f4f9;
}

/* 操作面板容器 */
.dashboard {
  max-width: 1200px;
  margin: 50px auto;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  padding: 30px;
}

/* 面板头部样式 */
.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* 用户名样式 */
.username {
  font-size: 24px;
  font-weight: 600;
  color: #333;
}

/* 退出按钮样式 */
.logout-btn {
  background-color: #e74c3c;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.logout-btn:hover {
  background-color: #c0392b;
}

/* 申请状态区域样式 */
.application-status {
  background-color: #f9f9f9;
  border: 1px solid #e1e1e1;
  border-radius: 5px;
  padding: 20px;
}

.application-status h3 {
  font-size: 18px;
  margin-bottom: 10px;
  color: #555;
}

.status-value {
  font-size: 16px;
  color: #777;
}
</style>
